module.exports = __webpack_public_path__ + "img/HZ-P3172.28b2754d.png";